import { render } from "./Cookies.vue?vue&type=template&id=2c23cd15&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=2c23cd15&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=2c23cd15&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src657459958/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c23cd15"]])

export default __exports__